import React from "react";

const KontakContent: React.FC = () => {
  return (
    <div className="min-h-screen py-24 px-6">
      <div className="max-w-[800px] mx-auto flex justify-center">
        {/* Contact Info Card */}
        <div className="relative bg-neutral w-full rounded-3xl shadow-2xl p-14">
          <div className="space-y-10">
            <h2 className="text-4xl font-bold">📬 Hubungi Kami</h2>
            <div className="space-y-6 text-xl leading-relaxed">
              <section>
                <h4 className="text-xl font-semibold mb-2">🏢 Alamat</h4>
                <p>Jln. Trunojoyo 3, Gedung TNCC Lt.11, Mabes Polri, Jakarta</p>
              </section>
              <section>
                <h4 className="text-xl font-semibold mb-2">📞 Kontak</h4>
                <p>
                  <strong>Email:</strong> ncb-jakarta@interpol.go.id
                </p>
                <p>
                  <strong>Telepon:</strong> 021 721 846 7
                </p>
                <p>
                  <strong>Fax:</strong> 021 720 140 2, 021 726 920 3
                </p>
              </section>
              <section>
                <h4 className="text-xl font-semibold mb-2">
                  ⏰ Jam Operasional
                </h4>
                <p>Senin - Jumat: 08.00 - 16.00</p>
                <p>Sabtu - Minggu: Libur</p>
              </section>

              <section>
                <h4 className="text-xl font-semibold mb-2">🔗 Sosial Media</h4>
                <div className="flex gap-6 text-blue-600 dark:text-blue-400 font-medium text-lg">
                  <button
                    type="button"
                    className="hover:underline focus:outline-none focus:underline"
                    onClick={() => alert("Link Instagram akan segera tersedia")}
                  >
                    Instagram
                  </button>
                  <button
                    type="button"
                    className="hover:underline focus:outline-none focus:underline"
                    onClick={() => alert("Link Twitter akan segera tersedia")}
                  >
                    Twitter
                  </button>
                  <button
                    type="button"
                    className="hover:underline focus:outline-none focus:underline"
                    onClick={() => alert("Link Facebook akan segera tersedia")}
                  >
                    Facebook
                  </button>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KontakContent;
